import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

Swiper.use([Autoplay, EffectFade]);

export default function () {
	// Initiate the swiper

	const heroCarousel = document.querySelectorAll('.js-hero-body');

	heroCarousel.forEach((carousel) => {
		if (carousel.querySelectorAll('.swiper-slide').length > 1) {
			const config = {
				allowTouchMove: false,
				autoplay: {
					delay: 5000,
				},
				effect: 'fade',
				fadeEffect: {
					crossFade: true,
				},
				slidesPerView: 1,
			};

			new Swiper(carousel, config);
		}
	});
}
